exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#games-page[data-v-b8b0e178]{background:#000}#games-page .card[data-v-b8b0e178]{background:#282828;border-radius:10px;color:#fff}#games-page .img-game[data-v-b8b0e178]{max-height:549px}#games-page .btn-mainkan[data-v-b8b0e178]{background:hsla(0,0%,40%,.4);border-radius:10px;font-style:normal;font-weight:600;font-size:14px;line-height:24px;text-align:center;color:#fff;width:100%}#games-page .btn-play[data-v-b8b0e178]{background-color:#e61b33}", ""]);

// exports
